<template>
  <elasticTableLogs :data="data" :loading="loading" :link-keys="linkKeys" :keys="keys" @fetch="onFetchData" />
</template>

<script>
import ElasticTableLogs from "@/core/components/ElasticTableLogs/index";
import logsMixin from "@/core/components/ElasticTableLogs/logsMixin";
import { ApiService } from "@/api";

export default {
  name: "ModelLogs",
  components: { ElasticTableLogs },
  mixins: [logsMixin],
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      keys: [
        "description",
        "is_onvif",
        "is_ptz",
        "is_wifi",
        "main_stream_bandwidth",
        "main_stream_resolution",
        "main_stream_template",
        "name",
        "port_onvif_default",
        "transcode_audio",
        "transcode_video",
        "url_onvif_template",
        "sub_stream_resolution",
        "sub_stream_template",
        "id_sidetask_setting",
        "onvif_media_profile_token",
        "serial_number_mask",
        "custom_sound_settings",
      ],
      linkKeys: {
        id: `${process.env.BASE_URL}#/`,
      },
    };
  },
  methods: {
    fetchLogs(params) {
      return ApiService.logs.getModelLogs(this.id, params);
    },
  },
};
</script>
